import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            追剧索引
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            按类型快速找到你想看的剧，海量片库精准导航
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group flex flex-col items-center text-center p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 transition-all duration-300 hover:scale-[1.03] cursor-pointer hover:border-primary-200"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="mt-4 text-sm md:text-base font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {item.name}
              </h3>
              <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}